<template>
  <b-card no-body class="card-stats">
    <div class="card-dashboard-content">
      <div class="row h-100" >
        <div :class="col_value_class" class=" px-md-3 px-1">
          <h3 class="card-title cardDashboardValueH3"
                v-bind:class="{
                  'card-dashboard-value-mid': client_name == 'MID',
                  'card-dashboard-value-dy': client_name == 'DY',
                }">
            {{ value }}
          </h3>
          <p class="card-category"
                v-bind:class="{
                  'card-dashboard-title-mid': client_name == 'MID',
                  'card-dashboard-title-dy': client_name == 'DY',
                }">{{ title }}</p>
        </div>
        <div :class="col_img_class" class=" dashboard-card-icon-container">
          <div class="dashboard-card-icon">
            <img
              class="dashboard-card-img"
              :src="getImgUrl(imgSrc)"
              alt="dashboard icon"
            />
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "DashboardCard",
  props: ["value", "title", "imgSrc","client_name"],
  props: {
    value: {
      type: Number
    },
    title: {
      type: String
    },
    imgSrc: {
      type: String
    },
    client_name: {
      type: String
    },
    col_value_class:{
      type:String,
      default:'col-7'
    },
    col_img_class:{
      type:String,
      default:'col-5'
    }
  },
  data() {
    return {};
  },
  methods: {
    getImgUrl(file_name) {
      // var images = require.context('@/assets/images', false, /\.png$/);
      // return images('./' + file_name + ".png")
      return require("@/assets/images/" + file_name+".png");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/dashboard/Card.vue